import React, { useState } from "react";
import TeamService from "services/TeamService";
import { useTimelineContext } from "store/contexts/timelineContext";
import Button from "components/CustomButton";
import { Modal } from "react-responsive-modal";
import { useToasts } from "react-toast-notifications";
import { ReactComponent as DeleteIcon } from "assets/img/icons/Delete.svg";

export default ({ myteam_id, post }) => {
  const { addToast } = useToasts();
  const { deletePost, setHide } = useTimelineContext();
  const [confimDeletePost, setConfirmDeletePost] = useState(false);

  const handleDeleteClicked = async () => {
    setHide(true);
    setConfirmDeletePost(true);
  };

  const closeDeleteModal = () => {
    setHide(false);
    setConfirmDeletePost(false);
  };

  const deleteMyPost = async () => {
    try {
      await TeamService.deletePost(myteam_id, post.id);

      deletePost(post);

      addToast("Post Deleted ", { appearance: "error" });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <span
        onClick={() => handleDeleteClicked()}
        style={{ cursor: "pointer" }}
        className="p-share-btn"
      >
        <DeleteIcon className="mwh-15" /> Delete
      </span>

      <Modal
        open={confimDeletePost}
        onClose={closeDeleteModal}
        showCloseIcon={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "rootModalContainer",
        }}
      >
        <div className="deleteConfirmationModal confirmationModalContent">
          <h5 className="text-center confirmationModalHeader">Delete Post</h5>
          <h6 className="confirmationModalDescription">
            Do you want to delete this post, kindly confirm.
          </h6>
          <div className="confirmationModalFooter">
            <Button buttonClass="small-btn me-2" onClick={closeDeleteModal}>
              Cancel
            </Button>
            <Button onClick={deleteMyPost} buttonClass=" small-reject-btn ">
              Confirm
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
